import { useEffect, useState } from "react";
import { MdVerified } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { ImSpinner2 } from "react-icons/im";
import { GetBlockList, UnblockUser } from "../services/api";
import { getMediaUrl } from "../utils/helpers";

export default function History() {

    const [blockList, setBlockList] = useState([]);
    const [blockedUsers, setBlockedUsers] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(new Set());

    useEffect(() => {
        if (blockList?.length) {
            const formatted = blockList.map(item => ({
                ...item,
                is_blocked: true, // default
            }));
            setBlockedUsers(formatted);
        }
    }, [blockList]);

    useEffect(() => {
        fetchBlockList();
    }, []);

    const fetchBlockList = () => {
        GetBlockList()
            .then((res) => {
                setBlockList(res.data);
            })
            .catch((err) => {
                console.log(err)
            });
    }

    const OnUnblockClick = async (userId) => {
        if (loadingUsers.has(userId)) return;

        setLoadingUsers(prev => new Set(prev).add(userId));

        try {
            await UnblockUser(userId);

            // ✅ REMOVE user from UI list after successful unblock
            setBlockedUsers(prev =>
                prev.filter(item => item.blockedUser._id !== userId)
            );

        } catch (err) {
            console.error(err);
        } finally {
            setLoadingUsers(prev => {
                const next = new Set(prev);
                next.delete(userId);
                return next;
            });
        }
    };

    return (
        <div className="min-h-screen bg-black text-white px-4 md:px-24 pt-[100px] pb-20 relative">

            {/* 🔹 EMPTY STATE WITHOUT BG BOX */}
            {blockedUsers.length === 0 && (
                <div className="w-full flex justify-center mt-40">
                    <p className="text-gray-400 text-lg">No blocked users to show</p>
                </div>
            )}

            {/* 🔹 LIST ONLY IF THERE ARE ITEMS */}
            {blockedUsers.length > 0 && (
                <div className="w-full flex justify-center">
                    <div className="w-full md:w-[50%] max-w-4xl bg-[#1f1f1f] rounded-2xl">

                        {blockedUsers.map((item, index) => (
                            <div
                                key={index}
                                className={`flex items-center justify-between px-3 md:px-6 py-3
                                        ${index !== blockedUsers.length - 1 ? "border-b border-gray-800" : ""}`}
                            >
                                {/* Avatar + Info */}
                                <div className="flex items-center gap-4">
                                    <img
                                        src={getMediaUrl(item?.blockedUser?.ppImageURL)}
                                        alt="avatar"
                                        className="w-12 h-12 rounded-full object-cover"
                                    />

                                    <div className="flex items-center gap-2 text-base font-medium">
                                        {item?.blockedUser.name}
                                        {item?.blockedUser.is_verified && (
                                            <MdVerified className="text-blue-400 text-lg" />
                                        )}
                                    </div>
                                </div>

                                {/* Unblock Button */}
                                <button
                                    onClick={() => OnUnblockClick(item?.blockedUser?._id)}
                                    disabled={loadingUsers.has(item?.blockedUser?._id)}
                                    className={`"flex items-center gap-2 border border-gray-400 px-4 py-2 rounded-full text-white font-medium hover:bg-white/10 transition
                                        ${loadingUsers.has(item?.blockedUser?._id) && "cursor-not-allowed opacity-70"}
                                    `}
                                >
                                    {loadingUsers.has(item?.blockedUser?._id) ? (
                                        <ImSpinner2 className="animate-spin text-base" />
                                    ) : (
                                        <div className="flex items-center gap-2">
                                            <RxCross2 className="text-white text-sm" />
                                            <span>Unblock</span>
                                        </div>
                                    )}
                                </button>
                            </div>
                        ))}

                    </div>
                </div>
            )}

        </div>
    );
}